import { render, staticRenderFns } from "./SignUpV2.vue?vue&type=template&id=72b1352c&scoped=true&"
import script from "./SignUpV2.vue?vue&type=script&lang=js&"
export * from "./SignUpV2.vue?vue&type=script&lang=js&"
import style0 from "./SignUpV2.vue?vue&type=style&index=0&id=72b1352c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b1352c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAlert,VBtn,VContainer,VImg})
